<template>
	<v-tooltip bottom>
		<template #activator="{ on, attrs }">
			<v-btn
				v-bind="attrs"
				icon
				class="ml-2 help-header-button"
				data-testid="help-assistant-header-button"
				:aria-label="helpAssistantOpen ? 'Close help assistant' : 'Open help assistant'"
				:aria-expanded="helpAssistantOpen ? 'true' : 'false'"
				aria-haspopup="dialog"
				@click="toggle"
				v-on="on"
			>
				<ai-assistant-icon data-testid="help-assistant-header-button-icon" />
			</v-btn>
		</template>
		<span>
			Help Assistant
		</span>
	</v-tooltip>
</template>

<script>
import AiAssistantIcon from './ai-assistant-icon.vue'
import { helpAssistantOpen, openHelpAssistant, closeHelpAssistant } from '../state/help-assistant.js'

/**
 * Help-assistant entry point in the shared header's top-right utility cluster (AB#27211), beside
 * the product switch button and styled to match it. Replaces the floating bottom-right FAB, which
 * collided with page-level primary actions and sticky action bars. Drives the same
 * `helpAssistantOpen` singleton as the splash page's "Help Assistant" card, so every entry point
 * opens the one sheet instance rendered by the portal's `help-launcher.vue`. `header.vue` renders
 * it only while such a host is mounted (`helpAssistantHostMounted`). The glyph is the brand
 * system's `ai-assistant` icon; the product switch button beside it was thinned from lucide's 2px
 * stroke to the brand's 1.5px to meet it.
 */
export default {
	name: 'help-header-button',
	components: { AiAssistantIcon },
	setup () {
		return { helpAssistantOpen }
	},
	methods: {
		toggle () {
			if (this.helpAssistantOpen) closeHelpAssistant()
			else openHelpAssistant()
		}
	}
}
</script>

<style lang="scss" scoped>
/*
  Same colour as the product switcher's trigger (component-library ProductSwitcher.vue), which this
  button sits beside: both are header affordances, not primary actions. It used to carry Vuetify's
  `color="primary"`, which made it the one blue glyph in a row of grey ones (AB#27211). Deep, because
  the glyph is a child component's own element rather than one authored here.
*/
.help-header-button ::v-deep svg {
	color: var(--global-header-text-color, #6b7280);
}
</style>
